module.exports = __webpack_public_path__ + "static/media/typed.a0ad2145.jpg";